import styled from "styled-components";

export const Box = styled.div`
  .interDisplay {
    font-family: InterDisplay;
  }
  .container_domain {
  }
  .container_domain .header {
    text-align: center;
    margin-bottom: 3rem;
  }

  .container_domain .header h1 {
    font-size: 2.5rem;
    color: #111827;
    margin-bottom: 1rem;
  }

  .container_domain .header p {
    font-size: 1.125rem;
    color: #4b5563;
  }

  .container_domain .error-message {
    margin-top: 1rem;
    padding: 1rem;
    background-color: #fef2f2;
    border-radius: 0.5rem;
    color: #ef4444;
    display: flex;
    align-items: center;
    gap: 0.5rem;
  }

  .container_domain .url-form {
    margin-bottom: 2rem;
  }

  .container_domain .input-group-box {
    display: flex;
    gap: 1rem;
  }

  .container_domain .input_checker {
    flex: 1;
    padding: 0.75rem 1rem;
    border: 1px solid #d1d5db;
    border-radius: 0.5rem !important;
    font-size: 1rem;
    outline: none;
    transition: border-color 0.2s, box-shadow 0.2s;
  }

  .container_domain.input_checker:focus {
    border-color: #3b82f6;
    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
  }

  .container_domain button {
    padding: 0.75rem 1.5rem;
    background-color: #8cc540;
    color: white;
    border: none;
    border-radius: 0.5rem;
    font-weight: 600;
    cursor: pointer;
    transition: background-color 0.2s;
    display: flex;
    align-items: center;
    gap: 0.5rem;
    margin-bottom: 0;
  }

  .container_domain button:hover {
    background-color: #8cc540;
  }

  .container_domain button:disabled {
    background-color: #d1d5db;
    cursor: not-allowed;
  }

  .container_domain .action-button {
    background: white;
    color: #374151;
    border: 1px solid #d1d5db;
    padding: 0.5rem 1rem;
    font-size: 0.875rem;
    display: flex;
    align-items: center;
    gap: 0.5rem;
  }

  .container_domain .action-button:hover {
    background: #f9fafb;
    // border-color: var(--gray-400);
  }
  .container_domain .result_card {
    background: white;
    border-radius: 0.75rem;
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1),
      0 2px 4px -1px rgba(0, 0, 0, 0.06);
    padding: 1.5rem;
    margin: 0 !important;
  }
  .container_domain .table-container {
    overflow-x: auto;
  }
  .container_domain table {
    width: 100%;
    border-collapse: collapse;
  }

  .container_domain th,
  td {
    padding: 0.75rem 1rem;
    text-align: left;
    border-bottom: 1px solid var(--gray-200);
  }

  .container_domain th {
    font-size: 0.875rem;
    font-weight: 600;
    color: #4b5563;
  }

  .container_domain .view-headers-btn {
    background: none;
    border: 1px solid #3b82f6;
    color: #3b82f6;
    padding: 0.25rem 0.5rem;
    font-size: 0.875rem;
    border-radius: 0.25rem;
  }
  .container_domain .view-headers-btn:hover {
    background: #3b82f6;
    color: white;
  }
  .detailViewBox {
    display: flex;
    color: #636363;
    margin-bottom: 5px;
    font-size: 18px;
  }
  .detailMainViewBox {
    max-height: 20rem;
    overflow: auto;
  }
  .buttonTabValidator {
    width: 100%;
    padding: 7px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
    font-weight: 600;
    cursor: pointer;
  }
  .mainTabButton {
    padding: 5px;
    border-bottom: 1px solid #d1d5db;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 15px;
  }

  @media (max-width: 768px) {
    .container_domain .input-group-box {
      display: block;
    }
    .container_domain .input_checker {
      width: 100%;
    }
    .container_domain button {
      margin-top: 1rem;
      width: 100%;
    }
  }
  @media (max-width: 410px) {
    .buttonTabValidator {
      font-size: 12px;
    }
    .mainTabButton {
      gap: 5px;
    }
  }

  .input-example {
  margin-top: 6px;
  font-size: 13px;
  color: #6b7280;
  line-height: 1.4;
}

.input-example a {
  color: #0073e6;
  text-decoration: none;
  word-break: break-all;
}

@media (max-width: 576px) {
  .input-example {
    font-size: 12px;
  }
}
  @media (max-width: 576px) {
  .input_checker::placeholder {
    font-size: 11px;
    white-space: nowrap;
  }
}
@media (max-width: 576px) {
  .input_checker {
    font-size: 13px; /* user input size */
  }
}

`;
